var map = {
	"./normal-cn.svg": 18862,
	"./normal-jp.svg": 89588,
	"./normal-kr.svg": 84839,
	"./normal-selected-cn.svg": 19186,
	"./normal-selected-jp.svg": 78671,
	"./normal-selected-kr.svg": 9694,
	"./normal-selected-tw.svg": 82155,
	"./normal-selected-us.svg": 56569,
	"./normal-tw.svg": 58812,
	"./normal-us.svg": 5299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51415;